/**
 * @param {('android' | 'ios' | 'desktop' | 'web' )} platform
 * @returns {Boolean} return
 */
export const checkInterpretationIsSupported = (platform) => {
  // Interpretation is not supported on iOS and android
  return !['ios', 'android'].includes(platform);
};
